import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { User } from '../models/user';

@Injectable()
export class AuthService {

	constructor(private afAuth: AngularFireAuth) { }

	public async logIn(user: User): Promise<firebase.User> {
		return this.afAuth.auth.signInWithEmailAndPassword(user.email, user.password) as Promise<firebase.User>;
	}

	public async logOut(): Promise<any> {
		return this.afAuth.auth.signOut() as Promise<any>;
	}

	public isLoggedIn(): boolean {
		if (this.afAuth.auth.currentUser != null) {
			return true;
		}

		return false;
	}

	public getDisplayName(): string {
		if (this.isLoggedIn()) {
			return this.afAuth.auth.currentUser.displayName || this.afAuth.auth.currentUser.email;
		}

		return '';
	}

	public getEmail(): string {
		if (this.isLoggedIn()) {
			return this.afAuth.auth.currentUser.email;
		}

		return '';
	}

	public getUID(): string {
		if (this.isLoggedIn()) {
			return firebase.auth().currentUser.uid;
		}

		return '';
	}

	public getToken(): Promise<any> {
		return this.afAuth.auth.currentUser.getIdToken() as Promise<any>;
	}

	public async resetPassword(email: string): Promise<any> {
		const auth = firebase.auth();

		return auth.sendPasswordResetEmail(email) as Promise<any>;
	}

	public async changePassword(code: string, password: string): Promise<any> {
		const auth = firebase.auth();

		return auth.confirmPasswordReset(code, password) as Promise<any>;
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/auth.service.ts